import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  MouseEventHandler,
  TouchEventHandler,
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { faLink } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import variables from 'scss/1-settings/colors.module.scss';
import { ClearIndicatorProps, GroupBase } from 'react-select';
import Button from 'components/Button';
import type { SelectFieldOptionObject } from '../SelectField/types';

import './SelectFieldCustomClearIndicator.scss';

type ClearIndicatorSelectProps = {
  onClearIndicatorMouseDown?: () => void;
  redirectUrl?: string;
};

const SelectFieldCustomClearIndicator = <
  Option extends SelectFieldOptionObject,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  innerProps,
  redirectUrl: redirectUrlProp,
  selectProps,
}: ClearIndicatorProps<Option, IsMulti, Group> & {
  innerProps?: DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  redirectUrl?: string;
}) => {
  const { onClearIndicatorMouseDown, redirectUrl: redirectUrlFromSelectProps } =
    (selectProps as ClearIndicatorSelectProps | undefined) || {};
  const redirectUrl = redirectUrlProp || redirectUrlFromSelectProps;

  const handleMouseDown: MouseEventHandler<HTMLDivElement> = event => {
    onClearIndicatorMouseDown?.();
    event.stopPropagation();
    innerProps?.onMouseDown?.(event);
  };

  const handleTouchEnd: TouchEventHandler<HTMLDivElement> = event => {
    onClearIndicatorMouseDown?.();
    event.stopPropagation();
    innerProps?.onTouchEnd?.(event);
  };

  return (
    <div
      style={{ fontSize: 16, zIndex: 1 }}
      className={cx({ 'select-field-clear-indicator': !!redirectUrl })}
    >
      {redirectUrl && (
        <Button
          className="select-field-link-button"
          onMouseDown={e => {
            e.stopPropagation();
            window.location.href = redirectUrl;
          }}
          icon={<FontAwesomeIcon icon={faLink} color={variables.gray400} />}
        />
      )}

      <div
        {...innerProps}
        onMouseDown={handleMouseDown}
        onTouchEnd={handleTouchEnd}
        role="presentation"
      >
        <FontAwesomeIcon icon={faTimesCircle} color={variables.gray400} />
      </div>
    </div>
  );
};

export default SelectFieldCustomClearIndicator;
